var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, Grid } from '@mui/material';
import { useState } from 'react';
import { DataTable } from 'ui-lib';
import { ClientLogger } from 'lib/client-logger';
import { EditTeam } from './EditTeam';
import { TopBackBtnBar } from '../../components/navigation/TopBackBtnBar';
import makeStyles from '@mui/styles/makeStyles';
import { tableClasses } from '../../style/sharedCssClasses';
import { SelectorNoForm } from 'ui-lib';
import { Loading } from 'components/widgets/Loading';
import { TeamMemberList } from './TeamMemberList';
import { useMultiAuth, useTeamService } from 'ui-lib';
var useClasses = makeStyles(__assign({}, tableClasses));
var DEBUG = false;
export var TeamList = function (props) {
    var $ = useMultiAuth().$;
    var classes = useClasses();
    var teamService = useTeamService();
    var _a = useState(false), editOrgOpen = _a[0], setEditOrgOpen = _a[1]; //false not open, undefined open with new, string teamId beiong edited
    var _b = useState(false), memberEdit = _b[0], setMemberEdit = _b[1]; //false not open,  string teamId beiong edited
    var orgs = $.getOrgs();
    var orgsSelectList = orgs.map(function (org) { return ({ id: org.id, name: org.name }); });
    var _c = useState($.currentOrgId()), currentOrgId = _c[0], setCurrentOrgId = _c[1];
    var _d = useState(''), teamName = _d[0], setTeamName = _d[1];
    var setSelectedOrgId = function (orgId) {
        setCurrentOrgId(orgId);
        $.saveCurrentOrgId(orgId);
    };
    var dataTableOptions = {
        pagination: true,
        download: true,
        print: true,
        filter: false,
        search: false,
        viewColumns: false,
        sort: true,
        selectableRows: 'none',
    };
    var columns = {
        id: { display: 'excluded' },
        name: { label: 'Name' },
        description: { display: 'excluded' },
        orgId: { display: 'excluded' },
        updatedAt: { display: 'excluded' },
        createdAt: { label: 'Created At' },
        status: { label: 'Status' },
        buttons: {
            label: '',
            customBodyRender: function (value) {
                if (value !== undefined && value !== null) {
                    return (_jsx(Box, __assign({ display: "flex", justifyContent: "space-evenly", alignItems: "center" }, { children: _jsx(Button, __assign({ color: "primary", variant: "contained", onClick: function () {
                                DEBUG && ClientLogger.debug('custom render click', '', value);
                                setTeamName(value.name);
                                setMemberEdit(value.id);
                            } }, { children: "Members" })) })));
                }
                else {
                    return _jsx(_Fragment, {});
                }
            },
            customHeadRender: function () { return _jsx("td", {}, "edit"); },
        },
    };
    var transformResponseToRows = function (resp) {
        var _a;
        if (!resp || !resp.teams || !((_a = resp.teams) === null || _a === void 0 ? void 0 : _a.edges)) {
            return [];
        }
        return resp.teams.edges.map(function (team) { return (__assign(__assign({}, team.node), { buttons: { id: team.node.id, name: team.node.name } })); });
    };
    var rowClicked = function (row) {
        setEditOrgOpen(row.id);
    };
    var tableProps = {
        useQuery: teamService.useTeamQuery({ variables: { orgId: currentOrgId || '' } }),
        initialQuery: {},
        transformResponseToRows: transformResponseToRows,
        columnAttributes: columns,
        tableAttributes: dataTableOptions,
        emptyMessage: 'No teams found. Click the + button to create a new team.',
        onAdd: function () {
            DEBUG && ClientLogger.debug('onAdd', '', {});
            setEditOrgOpen(undefined);
        },
        onRowClick: rowClicked,
    };
    DEBUG && ClientLogger.debug('OrgList', 'render', { tableProps: tableProps });
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, __assign({ container: true }, { children: [_jsx(TopBackBtnBar, { title: props.title }), _jsxs(Box, __assign({ mx: 2, mt: 6, mb: 1, className: classes.tableHolder }, { children: [_jsx(SelectorNoForm, { items: orgsSelectList, value: currentOrgId, onChange: function (item) { return setSelectedOrgId(item.id); } }), !currentOrgId ? (_jsx(Loading, {})) : (_jsx(_Fragment, { children: _jsx(DataTable, __assign({}, tableProps)) }))] }))] })), _jsx(Dialog, __assign({ open: !(editOrgOpen === false), onClose: function () { return setEditOrgOpen(false); }, maxWidth: "sm", fullWidth: true }, { children: _jsx(EditTeam, { onClose: function () {
                        setEditOrgOpen(false);
                    }, editingId: typeof editOrgOpen === 'string' ? editOrgOpen : undefined, dialogTitle: props.title, orgId: currentOrgId }) })), _jsx(Dialog, __assign({ open: !memberEdit === false, onClose: function () { return setMemberEdit(false); }, maxWidth: "sm", fullWidth: true }, { children: _jsx(TeamMemberList, { onClose: function () {
                        setMemberEdit(false);
                    }, teamId: memberEdit || '', title: "Edit Team Members for team ".concat(teamName), orgId: currentOrgId || '' }) }))] }));
};
